import * as angular from "angular";

angular
  .module('bringoz.admin.service-areas', [
    'ngMaterial',
    'bringoz.admin.shippers',
    'bringoz.admin.commons',
    'bringoz.admin.tasks',
    'bringoz.admin.routes',
    'bringoz.admin.agents'
  ]);
